/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_SKILL } from "./actionTypes"
import { apiError, addSkillSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addSkill } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addSkill, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al guardar la habilidad")
    yield put(addSkillSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* skillAddSaga() {
  yield takeEvery(ADD_SKILL, add)
}

export default skillAddSaga
